<template>
    <div id='step4'>
        <div class="tips">
            <StepTips title="核對清楚地址資料" text="一旦提交並不能再作出更改，需要重新預約。"/>
        </div>
        <div class="starSlipmentForm">
            <div class="h">
                <div class="startAddress">{{consignee.city}}</div> 
                <span>取件地址</span>
            </div>
            <div class="location">
                <div class="t">
                    <div class="name">{{consignee.name}}</div>
                    <div class="address">{{consignee.addressOne}} {{consignee.addressTwo}} {{consignee.addressThree}} {{consignee.description}} {{consignee.address}}</div>
                </div>
                <div class="b">
                    <div class="phone">
                        <div class="attr">{{consignee.phoneArea}}</div>
                        <div class="number">{{consignee.phone}}</div>
                    </div>
                    <div class="city">
                        {{consignee.city}}
                    </div>
                </div>
            </div>
            <div class="reserv">
                <div class="h">預約取件
                </div>
                    <el-date-picker
                    @change="setDate"
                    v-model="date"
                    type="date"
                    :picker-options="pickerOptions"
                    placeholder="選擇日期" style="margin-right: 50px;">
                  </el-date-picker>

                  <el-time-select
                  placeholder="最早取件时间"
                  v-model="startTime"
                  :picker-options="startOpt" 
                  style="margin-right: 30px;"
                  @change="(date)=>{setStartTim('startTime',date)}">
                </el-time-select>
                <el-time-select
                  placeholder="最晚取件时间"
                  v-model="endTime"
                  :picker-options="endOpt"
                  @change="setStartTim('endTime')">
                </el-time-select>
            </div>
        </div>
        <div class="nextBtn">
            <optionsButton :callback="next" title="下一步"/>
        </div>
    </div>
</template>

<script>
    // 引人组件
import StepTips from '@/components/StepTips.vue'
import optionsButton from '@/components/optionButton'
import {mapState} from 'vuex'
import { Loading } from 'element-ui';
import formatDate from "@/assets/js/actionDate.js"
export default {
    name:'Step4',
    components:{
        StepTips,
        optionsButton,
    },
    data(){
        return {
            // 当前预约的日期
            date:'',
            // 最早时间
            startTime:'',
            // 最早时间规则
            startOpt:{
                    start:  "00:00",
                    step: '00:30',
                    end: '23:59'
            },
            // 最晚时间规则
            endOpt:{
                    start:  "00:00",
                    step: '00:30',
                    end: '23:59',
            },
            // 最晚时间
            endTime:"",
            // 禁用日期
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
            },
        }
    },
    methods: {
        // 用户确认日期
        setDate(date){
            this.startTime = ""
            this.endTime = ""
            // 如果选择的日期是今天,就限制只能预约两小时后取件
            if(Date.parse(date)+ (12 * 60 * 60 * 1000) - Date.now() < (12 * 60 * 60 * 1000)){
                this.startOpt.start = formatDate(Date.now() + (2 * 60 * 60 * 1000 )).time
                this.endOpt.start = formatDate(Date.now() + (2.5 * 60 * 60 * 1000 )).time
            }else{
                this.startOpt.start = "00:00"
                this.endOpt.start = "00:00"
            }
            const newdate = formatDate(date).date
            // 选择日期后把寄件人地址的时间日期修改
            let orderUsers = this.$store.state.orderVo.orderUsers
            // 初始化vuex上的联系人
            this.$store.commit("INITORDERUSER")
            orderUsers= orderUsers.forEach(item => {
                if(item.typeId==1){
                    item.pickupDate = newdate
                }
                // 添加到vuex
                this.$store.commit("ADDORDERUSER",item)
            });
            if(false) return this.message.error("仅能选择两小时后的时间")
        },
        // 用户确定时间
        setStartTim(type,time){
            // 如果选择的是开始时间就限制结束时间
            if(type == "startTime" && time != null){
                console.log("startTime")
                let t = time.split(":") 
                // 结束时间和开始时间的间隔
                let step = 2.5
                // 计算出结束时间要加的时间戳
                let stamp = (t[0] * 60 * 60 * 1000) + (t[1] * 60 * 1000) + (step * 60 * 60 * 1000)
                this.endOpt.start = formatDate(Date.parse(this.date)+stamp).time
                console.log(this.endOpt)
            }
            let orderUsers = this.$store.state.orderVo.orderUsers
            // 初始化vuex上的联系人
            this.$store.commit("INITORDERUSER")
            orderUsers= orderUsers.forEach(item => {
                if(item.typeId==1){
                    item[type] = this[type]
                }
                // 添加到vuex
                this.$store.commit("ADDORDERUSER",item)
            });
        },
        // 下一步
        async next(){

            // 先判断用户是否已预约时间
            if(this.endTime == '' || this.startTime == '' || this.date == ''){
                return this.$message.error("请选择日期时间")
            }

            // 获取订单对象
            let orderVo = this.$store.state.orderVo
            // 过滤不需要的箱子
            if(this.$store.state.boxType == "01"){
                // 当前得箱子类型为信件
                orderVo.orderBoxes = orderVo.orderBoxes.filter(item=>{
                    console.log(item)
                    return item.boxType == "01"
                })
            }else{
                // 当前物品类型不为信件
                orderVo.orderBoxes = orderVo.orderBoxes.filter(item=>{
                    console.log(item)
                    return item.boxType != "01"
                })
            }
            console.log("过滤后的箱子",orderVo.orderBoxes)
            
            let loadingInstance = Loading.service();
            
            // 加工报关pdf数组
            let detailedPdf = []
            orderVo.order.detailedPdf.forEach(item =>{
                detailedPdf.push(item.url)
            } )
            orderVo.order.detailedPdf = JSON.stringify(detailedPdf)

            let orderRes = await this.$http.post(`app/v2/addOrder`,{
                ...orderVo
            })
            console.log(orderRes,"下单结果")
            if(!orderRes.data.success){
                loadingInstance.close();
                if(!orderRes.data.message) return this.$message.error("下單失敗，請確認您的資訊是否完整")
                return this.$message.error(orderRes.data.message)
            }
            loadingInstance.close();
            this.$message.success("下單成功")
            this.$router.push(`/order/${1}`)
        }
    },
    computed:{
        ...mapState({
            consignee:state=>state.orderVo.orderUsers[1],
        }),
    }
}
</script>

<style lang="less">
#step4{
    .starSlipmentForm,{
        .h{
            margin-top: 50px;
            margin-bottom:20px;
            display: flex;
            align-items: center;
            .startAddress{
                color: @colorMain;
                font-size: 18px;
                font-weight: 550;
                margin-right: 8px;
            }
        }
        .location{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            box-shadow: 0px 2px 7px #ccc;
            padding: 5px 20px;
            border-radius: 5px;
            height: 120px;
        .t,.b{
            width: 100%;
            display: flex;
            >div:first-child{
                width: 200px;
            }
        }
        .t{
            .name{
                font-weight: 550;
            }
        }
        .b{
            .phone{
                display: flex;
                .attr{
                    margin-right: 8px;
                }
            }
        }
    }
    .reserv{
        display: flex;
        flex-wrap: wrap;
        .h{
            font-size: 16px;
            font-weight: 550;
            width: 100%;
        }
    }
    }
    .nextBtn{
        margin-top: 50px;
        width: 100%;
        button{
            width: 100%;
        }
    }
}
</style>